<template>
  <div id="app">
    <router-view></router-view>
    <Toast />
  </div>
</template>

<script>
/* eslint-disable no-unused-vars*/
import travellaHeader from './components/TravellaHeader';
import Toast from 'primevue/toast';
export default {
  name: "app",
  data: function() {
    return {
      dane: Object
    };
  },
  components: {
    Toast,
  }
};
</script>

<style>
@import "./styles/fonts.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
img {
  max-width: 100%;
}
</style>
